"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardPoolCode = void 0;
const chain_1 = require("@zenlink-interface/chain");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const viem_1 = require("viem");
const CommandCode_1 = require("../../CommandCode");
const HEXer_1 = require("../../HEXer");
const PoolCode_1 = require("./PoolCode");
class StandardPoolCode extends PoolCode_1.PoolCode {
    constructor(pool, providerName) {
        super(pool, providerName);
        this.executor = {
            [chain_1.ParachainId.MOONBEAM]: '0xf6E1F3e311fF6783E44fA37aacD732270CEc8544',
            [chain_1.ParachainId.BASE]: '0x7b3f25a62F3557661812Ee91d9552d6fb6a57EDd',
            [chain_1.ParachainId.ASTAR]: '0x8291d744D5Fe8F9d5843CaBE6d6a82EB12b1E0B8',
        };
    }
    getProtocolExecutor() {
        const chainId = this.pool.token0.chainId;
        (0, tiny_invariant_1.default)(chainId !== undefined, 'StandardPoolCode: Unseted chainId');
        return this.executor[Number(chainId)];
    }
    getProtocolExecutorStartPoint() {
        return this.pool.address;
    }
    getSwapCodeForRouteProcessor(leg, _route, to) {
        // swapUniswapPool = 0x20(address pool, address tokenIn, bool direction, address to)
        const code = new HEXer_1.HEXer()
            // swapUniswapPool
            .uint8(CommandCode_1.CommandCode.SWAP_UNISWAP_V2)
            .address(this.pool.address)
            .address(leg.tokenFrom.address)
            .bool(leg.tokenFrom.address === this.pool.token0.address)
            .address(to)
            .toString();
        (0, tiny_invariant_1.default)(code.length === 62 * 2, 'getSwapCodeForRouteProcessor unexpected code length');
        return code;
    }
    getSwapCodeForRouteProcessor2(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .uint8(0) // uniV2 pool
            .address(this.pool.address)
            .bool(leg.tokenFrom.address === this.pool.token0.address)
            .address(to)
            .toString();
        return code;
    }
    getSwapCodeForAggregationRouter(leg, _route, to) {
        const code = new HEXer_1.HEXer()
            .address(this.getProtocolExecutor())
            .bytes((0, viem_1.encodeAbiParameters)((0, viem_1.parseAbiParameters)('address, uint8, address'), [
            this.pool.address,
            leg.tokenFrom.address === this.pool.token0.address ? 1 : 0,
            to,
        ]))
            .toString();
        return code;
    }
}
exports.StandardPoolCode = StandardPoolCode;
